<div class="main-container">
    <div class="main-page">
        <div class="prospect-detail">
            <div class="white-card">
                <div class="header-title-row">
                    <div class="header-left">
                        <img src="assets/svg/opportunities-icon.svg" alt="oportunidades" class="center-svg"/>
                        <h1 class="text-semibold color-org t-24">Oportunidades</h1>
                        <div class="dropdown-wrapper" #dropdownContainer>
                            <div class="dropdown-trigger" (click)="toggleRecentDropdown()">
                                <span>{{selectedItem === 'recientes' ? 'Mis oportunidades' : 'Todas las oportunidades'}}</span>
                                <span [class.rotated]="showRecentDropdown">▼</span>
                                <div class="dropdown-menu" [class.show]="showRecentDropdown">
                                    <button class="dropdown-item" [class.selected]="selectedItem === 'todas'" (click)="selectItem('todas')">
                                        <span class="check-icon" *ngIf="selectedItem === 'todas'">✔</span>
                                        Todas las oportunidades
                                    </button>
                                    <button class="dropdown-item" [class.selected]="selectedItem === 'recientes'" (click)="selectItem('recientes')">
                                        <span class="check-icon" *ngIf="selectedItem === 'recientes'">✔</span>
                                        Mis oportunidades
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="header-actions">
                        <button *ngIf="permissionService.hasPermission('Oportunidades', 'Crear')" class="action-btn outline" (click)="openMdlCreateOportunity()">
                            <img src="assets/svg/plus-orange.svg" alt="Vista resumen" width="16" height="16" />
                            Nuevo
                        </button>
                        <button class="action-btn primary" (click)="goOpportunitiesGeneral()">
                            <img src="assets/svg/stast-white.svg" alt="Añadir nuevo" width="16" height="16" />
                            Oportunidades en curso
                        </button>
                    </div>
                </div>
                <div class="header-stats mt-3">
                    <span>{{oportunidadesFiltradas.length}} elementos | Se actualizó hace 2 minutos</span>
                    <span *ngIf="hasActiveFilters()" class="filter-badge" style="margin-left: 10px;">
                        Filtros aplicados
                        <button (click)="clearFilters()" class="clear-filters-btn">×</button>
                    </span>
                </div>

                <div class="content-area mt-5">
                    <div *ngIf="errorMessage" class="error-message">
                        {{errorMessage}}
                    </div>
                    <div *ngIf="!isLoading && oportunidades.length > 0">
                        <div class="d-grid search-bar-container" style="
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            width: 100%;
                            gap: 16px;
                        ">
                            <div class="npt-table-search-bar d-grid" style="flex: 1; min-width: 0">
                                <div><img src="assets/svg/search.svg" alt=""></div>
                                <input 
                                    type="text" 
                                    class="npt-nav-search" 
                                    placeholder="Buscar en esta lista..."
                                    [(ngModel)]="searchTerm"
                                    (input)="onSearchChange()"
                                    style="flex: 1; min-width: 0; width: 100%"
                                >
                            </div>
                            <div style="display: flex; gap: 12px; flex-shrink: 0">
                                <button class="search-btn" (click)="cargarOportunidades()" style="display: flex; align-items: center; gap: 6px; white-space: nowrap;">
                                    <img src="assets/svg/reload-icon.svg" alt="Actualizar">
                                    <span>Actualizar</span>
                                </button>
                                <button class="search-btn" (click)="openFilterModal()" style="display: flex; align-items: center; gap: 6px; white-space: nowrap;">
                                    <img src="assets/svg/filtrar-icon.svg" alt="Filtrar">
                                    <span>Filtrar</span>
                                </button>
                            </div>
                        </div>

                        <div class="prospectos-table mh-50">
                            <table>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th class="checkbox-column text-center">
                                            <img src="assets/svg/checkline-icon.svg">
                                        </th>
                                        <th 
                                            (click)="sortByColumn('nombre')"
                                            [class.sorted]="sortColumn === 'nombre'"
                                            class="sortable-header"
                                        >
                                            Nombre de la oportunidad
                                            <span *ngIf="sortColumn === 'nombre'" class="sort-indicator">
                                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </th>
                                        <th 
                                            (click)="sortByColumn('cuenta.nombre_empresa')"
                                            [class.sorted]="sortColumn === 'cuenta.nombre_empresa'"
                                            class="sortable-header"
                                        >
                                            Nombre de la cuenta
                                            <span *ngIf="sortColumn === 'cuenta.nombre_empresa'" class="sort-indicator">
                                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </th>
                                        <th 
                                            (click)="sortByColumn('importe_actual')"
                                            [class.sorted]="sortColumn === 'importe_actual'"
                                            class="sortable-header"
                                        >
                                            Importe
                                            <span *ngIf="sortColumn === 'importe_actual'" class="sort-indicator">
                                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </th>
                                        <th
                                            (click)="sortByColumn('importe_total_contrato')"
                                            [class.sorted]="sortColumn === 'importe_total_contrato'"
                                            class="sortable-header"
                                        >
                                            Importe Contrato
                                            <span *ngIf="sortColumn === 'importe_total_contrato'" class="sort-indicator">
                                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                            </span>

                                        </th>
                                        <th 
                                            (click)="sortByColumn('fecha_cierre_estimada')"
                                            [class.sorted]="sortColumn === 'fecha_cierre_estimada'"
                                            class="sortable-header"
                                        >
                                            Fecha de cierre
                                            <span *ngIf="sortColumn === 'fecha_cierre_estimada'" class="sort-indicator">
                                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </th>
                                        <th 
                                            (click)="sortByColumn('etapa')"
                                            [class.sorted]="sortColumn === 'etapa'"
                                            class="sortable-header"
                                        >
                                            Etapa
                                            <span *ngIf="sortColumn === 'etapa'" class="sort-indicator">
                                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </th>
                                        <th 
                                            (click)="sortByColumn('probabilidad_cierre')"
                                            [class.sorted]="sortColumn === 'probabilidad_cierre'"
                                            class="sortable-header"
                                        >
                                            Probabilidad
                                            <span *ngIf="sortColumn === 'probabilidad_cierre'" class="sort-indicator">
                                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </th>
                                        <th 
                                            (click)="sortByColumn('tipo_negocio')"
                                            [class.sorted]="sortColumn === 'tipo_negocio'"
                                            class="sortable-header"
                                        >
                                            Tipo
                                            <span *ngIf="sortColumn === 'tipo_negocio'" class="sort-indicator">
                                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </th>
                                        <th 
                                            (click)="sortByColumn('contacto.ejecutivo.nombre')"
                                            [class.sorted]="sortColumn === 'contacto.ejecutivo.nombre'"
                                            class="sortable-header"
                                        >
                                            Nombre completo del propietario
                                            <span *ngIf="sortColumn === 'contacto.ejecutivo.nombre'" class="sort-indicator">
                                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let oportunidad of oportunidadesFiltradas; let i=index" (click)="verDetalleOportunidad(oportunidad.oportunidad_id, $event)">
                                        <td class="counter-cell">{{ i + 1 }}.</td>
                                        <td class="checkbox-column">
                                            <input type="checkbox" (click)="$event.stopPropagation()">
                                        </td>
                                        <td>{{ oportunidad.nombre?.charAt(0)?.toUpperCase() + oportunidad.nombre?.slice(1) }}</td>
                                        <td>{{ oportunidad?.cuenta?.nombre_empresa?.charAt(0)?.toUpperCase() + oportunidad?.cuenta?.nombre_empresa?.slice(1) }}</td>
                                        <td>CLP {{ oportunidad.importe_actual | number: '1.0-0' }}</td>
                                        <td>CLP {{ oportunidad.importe_total_contrato | number:'1.0-0'}}</td>
                                        <td>{{ oportunidad.fecha_cierre_estimada | date: 'yyyy/MM/dd' }}</td>
                                        <td>{{ oportunidad.etapa?.charAt(0)?.toUpperCase() + oportunidad.etapa?.slice(1) }}</td>
                                        <td>{{ oportunidad.probabilidad_cierre | number: '1.0-0' }}%</td>
                                        <td>{{ oportunidad.tipo_negocio?.charAt(0)?.toUpperCase() + oportunidad.tipo_negocio?.slice(1) }}</td>
                                        <td>
                                            {{ oportunidad?.contacto?.ejecutivo?.nombre }} {{ oportunidad?.contacto?.ejecutivo?.apellido }}
                                        </td>
                                        <td class="actions-cell">
                                            <div class="dropdown-container" (click)="$event.stopPropagation()">
                                                <button class="dots-button" (click)="toggleActionsMenu('menu-' + oportunidad.id)">
                                                    <svg class="dots-icon" viewBox="0 0 24 24">
                                                        <circle cx="12" cy="5" r="2"/>
                                                        <circle cx="12" cy="12" r="2"/>
                                                        <circle cx="12" cy="19" r="2"/>
                                                    </svg>
                                                </button>
                                                <div class="dropdown-menu" [class.show]="openedMenuId === 'menu-' + oportunidad.id">
                                                    <button *ngIf="permissionService.hasPermission('Oportunidades', 'Editar')" class="dropdown-item" (click)="updateOportunity(oportunidad)">Modificar</button>
                                                    <button *ngIf="permissionService.hasPermission('Oportunidades', 'Eliminar')" class="dropdown-item" (click)="openMdlDeleteOportunity(oportunidad.id)">Eliminar</button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div *ngIf="!isLoading && oportunidades.length === 0 && !errorMessage" class="empty-state">
                        <div class="empty-content">
                            <div class="empty-image">
                                <img src="assets/img/listaprospecto.png" alt="Lista de prospectos vacía" />
                            </div>
                            <h2>Sin oportunidades por ahora</h2>
                            <p>Todavía no tienes oportunidades registradas. Puedes comenzar agregando una nueva.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>